<template ref="formContainer">
    <div class="profile-page">
        <section class="section-profile-cover section-shaped my-0">
            <div class="shape shape-style-1 shape-primary shape-skew alpha-4">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
        </section>
        <section class="section section-skew" >
            <div class="container">
                <div class="row justify-content-center">
                <div class="col-lg-5">
                    <card type="white" shadow
                        header-classes="bg- pb-5"
                        body-classes="px-lg-3 py-lg-3"
                        class="border-0" v-if="!cfdi">
                        <template>
                            <div class="text-center text-muted mb-4">
                                <span class="text-success font-weight-700">Ingresa el folio de la factura y el RFC del Receptor</span>
                        </div>
                            <form role="form">
                                <small class="text-secondary">  El folio debe iniciar con las letras, FC,FG,FF,FA o FD. Ejemplo ( FG-90029839 )</small>
                                <base-input alternative
                                v-model="folio"
                                placeholder="Folio factura"
                                addon-left-icon="ni ni-zoom-split-in"
                                required
                                :valid="textfolio"
                                v-on:keyup="validar_input('folio')"
                                class="mb-3">
                                </base-input>
                                <base-input alternative
                                v-model="rfc"
                                placeholder="RFC Receptor"
                                addon-left-icon="ni ni-zoom-split-in"
                                :valid="textrfc"
                                v-on:keyup="validar_input('rfc')"
                                class="mb-3">
                                </base-input>
                                <div class="text-center">
                                    <base-button type="secondary" @click="buscar()" class="my-4">Buscar</base-button>
                                </div>
                            </form>
                        </template>
                    </card>
                    <card class="border-0" hover shadow body-classes="py-3" v-if="cfdi">
                                    
                                    <h6 class="text-success">Factura valida <base-button type="danger" v-if="cfdi" @click="limpiar()" class="btn-sm ">Buscar otro</base-button></h6>
                                
                                <ul class="list-unstyled mt-5">
                                <li class="py-2">
                                    <div class="d-flex align-items-center">
                                        <badge type="info" class="mr-3" icon="ni ni-settings-gear-65">Folio:</badge>
                                        <h6 class="mb-0">{{cfdi.folio_completo}}</h6>
                                    </div>
                                </li>
                                <li class="py-2">
                                    <div class="d-flex align-items-center">
                                        <badge type="info" class="mr-3" icon="ni ni-satisfied">Fecha:</badge>
                                        <h6 class="mb-0">{{cfdi.fecha_emision}}</h6>
                                    </div>
                                </li>
                                <li class="py-2">
                                    <div class="d-flex align-items-center">
                                        <badge type="info" class="mr-3" icon="ni ni-satisfied">RFC:</badge>
                                        <h6>{{cfdi.rfc_receptor}}</h6>
                                    </div>
                                </li>
                                <li class="py-2">
                                    <div class="d-flex align-items-center">
                                        <badge type="info" class="mr-3" icon="ni ni-html5">UUID:</badge>
                                        <small class="mb-0">{{cfdi.uuid }}</small>
                                    </div>
                                </li>
                                <li>
                                    <div class="d-flex align-items-center">
                                        <base-button tag="a" href="#" @click="downloadxml()"  type="primary" class="mt-4 btn-md">
                                        Descargar xml <i class="fa fa-file-text-o" aria-hidden="true"></i>
                                    </base-button>
                                    <base-button tag="a" href="#" @click="downloadpfd()" type="primary" class="mt-4 ml-2 btn-md">
                                        Descargar Pdf <i class="fa fa-file-pdf-o" aria-hidden="true"></i>
                                    </base-button>
                                    </div>
                                </li>
                            </ul>
                            </card>
                </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
import Loading from 'vue-loading-overlay';
export default {
    data(){
        return {
        folio: "",
        formSubmitted: false,
        cfdi:null,
        rfc:"",
        textfolio:false,
        textrfc:false
        };
    },
    components:{
        Loading
    },
    methods:{
        limpiar(){
            this.cfdi=null;
            this.folio="";
            this.textfolio=false;
        },
        formatDate(dateString) {
            const date = new Date(dateString);
            return new Intl.DateTimeFormat().format(date);
        },
        validar_input(param){
            if(param==='folio'){
                this.textfolio=false;
                if(this.folio!=''){
                    this.textfolio=true;
                }
            }else{
                this.textrfc=false;
                if(this.rfc.length===12 || this.rfc.length===13){
                    this.textrfc=true;
                }
            }
        },
        buscar:function(){
            let homeCont = this.$refs.formContainer;
            if(this.folio==''){
                this.$swal('Ingrese el folio');
                return;
            }
            if(this.rfc==''){
                this.$swal('Ingrese el rfc del receptor!!!');
                return;
            }
            let loader = this.$loading.show(
                    {
                        container: homeCont,
                        loader: 'spinner',
                    }
                    );
            this.axios.post('https://apisia.cesavesin.mx/repositorioCfdi/obtenerCfdi',{folio:this.folio,rfc:this.rfc})
            .then((response) =>response.data)
            .then(resp=>{
                loader.hide()
                this.cfdi=resp.data;
                //console.log(this.cfdi)
                this.cfdi.fecha_emision=this.formatDate(this.cfdi.fecha_emision)
            }).catch(err=>{
                loader.hide()
                this.$swal(err.response.data.message,'','error');
            })
        },
        downloadpfd:function(){
            let arr=this.cfdi.fecha_emision.split('/');
            window.open(`https://apisia.cesavesin.mx/clientecfdi/downloadpdf?uuid=${this.cfdi.uuid}`);
            //window.location.reload()
        },
        downloadxml:function(){
            let arr=this.cfdi.fecha_emision.split('/');
            window.open(`https://apisia.cesavesin.mx/clientecfdi/downloadxml?uuid=${this.cfdi.uuid}`);
            //window.location.reload()
        },
    }
};
</script>
<style>
.loading-parent {
    position: relative;
}
</style>
